<template>
  <div>
    <!--摄影订单新增，表单 -->
    <el-dialog :title="$t('message.createANewTaskOrder')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="580px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <!-- 订单号 -->
          <el-form-item :label="$t('message.orderNumber')" prop="order_sn">
            <el-input v-model="ruleForm.order_sn"></el-input>
          </el-form-item>
          <!-- 拍摄数量 -->
          <el-form-item :label="$t('message.numberOfShotsTaken')" prop="predict_num">
            <el-input v-model="ruleForm.predict_num" type="number"></el-input>
          </el-form-item>
          <!-- 预计完成时间 -->
          <el-form-item :label="$t('message.expectedCompletionTime')" prop="predict_complete_at">
            <el-date-picker v-model="ruleForm.predict_complete_at" type="datetime" placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <!-- 上传文件 -->
          <el-form-item :label="$t('message.uploadFiles')">
            <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :on-success="handleSuccess"
              :on-remove="handleRemove" multiple :file-list="ruleForm.fileList">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <!-- 业务备注 -->
          <el-form-item :label="$t('message.serviceRemarks')" prop="y_remark">
            <el-input v-model="ruleForm.y_remark" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
      $t("message.cancel")
    }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
      $t("message.save")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    itemData: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        order_sn: '',
        predict_num: '',
        predict_complete_at: '',
        file: [],
        y_remark: '',
        fileList: [],
      },
      rules: {
        order_sn: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        predict_num: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        predict_complete_at: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        fileList: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "change",
          },
        ],

      },
    };
  },
  methods: {
    // 保存
    save() {

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.fileList.forEach(item => {
            this.ruleForm.file.push(item.response.data)
          })
          this.$api.photo.storeJob(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.ruleForm = {
              order_sn: '',
              predict_num: '',
              predict_complete_at: '',
              file: [],
              y_remark: '',
              fileList: [],
            }
            this.dialogVisible = false
          });
        }
      })

    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.fileList = fileList
    },
    handleSuccess(response, file, fileList) {
      this.ruleForm.fileList = fileList
      console.log(this.fileList);
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  /deep/.el-date-editor {
    width: 100%;
  }

}
</style>